function toggleFreeGiftSection(cart) {
  console.log("toggleFreeGiftSection appelé (Mode Compatible)");

  function updateGiftSection() {
    console.log("updateGiftSection appelé");
    var freeGiftSection = document.getElementById('free-gift-section');
    var freeGiftContainer = document.getElementById('freegiftblock');

    if (!freeGiftSection || !freeGiftContainer) {
      console.log("freeGiftSection non trouvé dans le DOM");
      return;
    }

    // --- SYNTAXE ANCIENNE (COMPATIBLE VIEUX IPHONE) ---
    // On n'utilise pas le ?. ni les flèches =>
    var gift1 = null;
    var gift2 = null;

    if (cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.properties && item.properties['_cadeau'] === '_offert1') {
          gift1 = item;
        }
        if (item.properties && item.properties['_cadeau'] === '_offert2') {
          gift2 = item;
        }
      }
    }
    
    var totalPrice = cart.total_price;
    
    // Logique d'affichage
    // On ajoute 'show' pour afficher
    if (totalPrice >= 8000 && !gift2) {
      freeGiftContainer.classList.add('show');
    } else if (totalPrice >= 5000 && !gift1) {
      freeGiftContainer.classList.add('show'); 
    } else {
      freeGiftContainer.classList.remove('show');
    }

    // Suppression automatique
    if (totalPrice < 5000 && gift1) {
      removeGiftItemByCadeau(1);
    } else if (totalPrice < 8000 && gift2) {
      removeGiftItemByCadeau(2);
    }
  }

  // --- LOGIQUE DE DÉTECTION (OBSERVER) ---
  // Si l'élément est déjà là, on lance
  if (document.getElementById('free-gift-section')) {
    updateGiftSection();
  } else {
    // Sinon on attend qu'il apparaisse (Compatible IE11+)
    var observer = new MutationObserver(function(mutationsList, obs) {
      for (var j = 0; j < mutationsList.length; j++) {
        var mutation = mutationsList[j];
        if (mutation.type === 'childList') {
           // On vérifie si la section est apparue
           if (document.getElementById('free-gift-section')) {
             console.log("Section détectée via Observer");
             updateGiftSection();
             obs.disconnect(); // On arrête d'observer
             break;
           }
        }
      }
    });

    // On observe le body pour voir si le AJAX injecte le code
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

// --- FONCTION DE SUPPRESSION (COMPATIBLE) ---
function removeGiftItemByCadeau(propertyValue) {
  var selector = '[data-cadeau' + propertyValue + '="true"]';
  if (window.location.pathname === '/cart') {
    selector = 'tr.cart-item' + selector;
  }
  
  var giftItem = document.querySelector(selector);

  if (giftItem) {
    var removeBtn = giftItem.querySelector('cart-remove-button');
    // Vérification à l'ancienne sans ?.
    var lineIndex = (removeBtn && removeBtn.dataset) ? removeBtn.dataset.index : null;
    
    if (lineIndex) {
      var cartItemsElement = document.querySelector('cart-items');
      if (cartItemsElement && typeof cartItemsElement.updateQuantity === 'function') {
        cartItemsElement.updateQuantity(lineIndex, 0);
      }
    }
  }
}

// --- ÉCOUTEURS D'ÉVÉNEMENTS ---
function refreshCartData() {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) { toggleFreeGiftSection(cart); })
        .catch(function(err) { console.error(err); });
}

// 1. Au chargement
document.addEventListener('DOMContentLoaded', refreshCartData);

// 2. Quand la page est chargée par le thème
document.addEventListener('page:loaded', refreshCartData);

// 3. Quand un produit est ajouté (AJAX)
document.addEventListener('ajaxProduct:added', refreshCartData);

// 4. LE FIX EST ICI : On force le refresh quoi qu'il arrive
// On ne vérifie plus evt.detail, on recharge tout le temps.
document.addEventListener('cart:updated', refreshCartData);